import { render, staticRenderFns } from "./z-back-button.vue?vue&type=template&id=78c3aa98&scoped=true&"
var script = {}
import style0 from "./z-back-button.vue?vue&type=style&index=0&id=78c3aa98&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c3aa98",
  null
  
)

export default component.exports